<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>location_city</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.communications' | translate}}</span>
      </div>
      <!-- / APP TITLE -->


      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>

        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->

        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <div></div>

      <!-- / SEARCH -->
    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    @if (emails.length) {
      <div class="content-card mat-white-bg">
        <div class="mail-content">
          <div class="all-emails">
            @for (mails of emails; track mails) {
              <div class="email" (click)="chooseMail(mails, mails.id)" id="{{mails.id}}"
                [style.fontWeight]="mails.readByAdmin ? 'normal' : 'bold'">
                <div class="date">{{mails.createdAt | date: 'EEE, d. MMMM HH:mm'}}</div>
                <div class="title">
                  {{mails?.title}}
                </div>
              </div>
            }
          </div>
          <div class="email-description">
            @if (mailTitle) {
              <div class="ed-title">{{mailTitle}}</div>
            }
            @if (mailBody) {
              <div class="show-more" >
                <span (click)="deleteEmail(chosenEmail)">{{'Delete' | translate}}</span>
              </div>
            }
            @if (mailBody) {
              <div [innerHTML]="mailBody">
              </div>
            }
          </div>
        </div>
        <mat-paginator #paginator [style.dislay]="emails.length ? 'block' : 'none'"
          [length]="totalCount"
          [pageIndex]="_pageIndex"
          [pageSize]="_perPage"
          [pageSizeOptions]="[10, 25, 50]"
          (page)="changePageEmitter($event)">
        </mat-paginator>
      </div>
    }
    @if (emails.length === 0) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{'no_news' | translate}}</span>
      </div>
    }
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
